function Towns() {
    return (
        <div>
            <h2>Towns</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default Towns;